import * as React from 'react';
import { withAngularIntegration } from '../../common/componentUtils/reactComponentRegistration';
import { OneWayBinding } from '../../common/angularData';
import { useAngularServiceContext } from '../../common/componentUtils/angularServiceContexts';
import { LeftNavigationContainer } from './LeftNavigationContainer';

type LeftNavigationAngularWrapperProps = {
    bannerHeightPx: string;
    isLeftNavbarEnabled: boolean;
};

export function LeftNavigationAngularWrapper({
    bannerHeightPx,
    isLeftNavbarEnabled,
}: LeftNavigationAngularWrapperProps): JSX.Element {
    const mvIdentity = useAngularServiceContext('mvIdentity');

    const isLoggedIn = React.useMemo(() => mvIdentity.isAuthenticated(), [mvIdentity]);

    return <>{isLeftNavbarEnabled && isLoggedIn && <LeftNavigationContainer topOffsetBanner={bannerHeightPx} />}</>;
}

LeftNavigationAngularWrapper.displayName = 'LeftNavigationAngularWrapper';

export const LeftNavigationAngularWrapperWithAngular = withAngularIntegration(
    LeftNavigationAngularWrapper,
    'leftNavigationAngularWrapper',
    {
        bannerHeightPx: OneWayBinding,
        isLeftNavbarEnabled: OneWayBinding,
    },
);
